module.exports = __webpack_public_path__ + "img/circle_gray.abe7705f.png";